<template>
  <div>
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'client-bonuses-playthrough' }" active-class="is-active" tag="li"><a>Playthrough</a></router-link>
        <router-link :to="{ name: 'client-bonuses-cashback' }" active-class="is-active" tag="li"><a>Cashback</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'client-bonuses'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bonuses/index.vue